import { Injectable, NgModule } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
import * as ɵngcc0 from '@angular/core';
class AuthServiceConfig {
    /**
     * @param {?} providers
     * @param {?} autoLogin
     */
    constructor(providers, autoLogin) {
        this.providers = new Map();
        this.autoLogin = autoLogin;
        for (let i = 0; i < providers.length; i++) {
            /** @type {?} */
            const element = providers[i];
            this.providers.set(element.id, element.provider);
        }
    }
}
class AuthService {
    /**
     * @param {?} config
     */
    constructor(config) {
        this._authState = new BehaviorSubject(null);
        this._user = null;
        this.providers = config.providers;
        if (config.autoLogin) {
            this.providers.forEach((provider, key) => {
                if (provider) {
                    provider.initialize().then((user) => {
                        user.provider = key;
                        this._user = user;
                        this._authState.next(user);
                    }).catch((err) => {
                        // this._authState.next(null);
                    });
                }
            });
        }
    }
    /**
     * @return {?}
     */
    get authState() {
        return this._authState.asObservable();
    }
    /**
     * @param {?} providerId
     * @return {?}
     */
    signIn(providerId) {
        return new Promise((resolve, reject) => {
            /** @type {?} */
            const providerObject = this.providers.get(providerId);
            if (providerObject) {
                if (providerObject.isInitialize) {
                    providerObject.signIn().then((user) => {
                        user.provider = providerId;
                        resolve(user);
                        this._user = user;
                        this._authState.next(user);
                    });
                }
                else {
                    providerObject.initialize().then((user) => {
                        if (user) {
                            user.provider = providerId;
                            resolve(user);
                            this._authState.next(user);
                        }
                        else {
                            providerObject.signIn().then((u) => {
                                u.provider = providerId;
                                resolve(u);
                                this._user = u;
                                this._authState.next(u);
                            });
                        }
                    }).catch((err) => {
                        // this._authState.next(null);
                    });
                }
            }
            else {
                reject(AuthService.LOGIN_PROVIDER_NOT_FOUND);
            }
        });
    }
    /**
     * @return {?}
     */
    signOut() {
        return new Promise((resolve, reject) => {
            if (this._user && this._user.provider) {
                /** @type {?} */
                const providerId = this._user.provider;
                /** @type {?} */
                const providerObject = this.providers.get(providerId);
                providerObject.signOut().then(() => {
                    this._user = null;
                    this._authState.next(null);
                    resolve();
                }).catch((err) => {
                    this._authState.next(null);
                });
            }
            else {
                reject(AuthService.LOGIN_PROVIDER_NOT_FOUND);
            }
        });
    }
}
AuthService.ɵfac = function AuthService_Factory(t) { return new (t || AuthService)(ɵngcc0.ɵɵinject(AuthServiceConfig)); };
AuthService.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: AuthService, factory: AuthService.ɵfac });
AuthService.LOGIN_PROVIDER_NOT_FOUND = 'Login provider not found';
/** @nocollapse */
AuthService.ctorParameters = () => [
    { type: AuthServiceConfig }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(AuthService, [{
        type: Injectable
    }], function () { return [{ type: AuthServiceConfig }]; }, null); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class SocialLoginModule {
    /**
     * @return {?}
     */
    static forRoot() {
        return {
            ngModule: SocialLoginModule,
            providers: [AuthService]
        };
    }
}
SocialLoginModule.ɵfac = function SocialLoginModule_Factory(t) { return new (t || SocialLoginModule)(); };
SocialLoginModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: SocialLoginModule });
SocialLoginModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ providers: [
        AuthService
    ] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SocialLoginModule, [{
        type: NgModule,
        args: [{
                imports: [],
                declarations: [],
                providers: [
                    AuthService
                ]
            }]
    }], null, null); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class SocialUser {
}
class LoginProviderClass {
}
class LinkedInResponse {
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * @abstract
 */
class BaseLoginProvider {
    constructor() { }
    /**
     * @param {?} obj
     * @param {?} onload
     * @return {?}
     */
    loadScript(obj, onload) {
        if (document.getElementById(obj.name)) {
            return;
        }
        /** @type {?} */
        const signInJS = document.createElement('script');
        signInJS.async = true;
        signInJS.src = obj.url;
        signInJS.onload = onload;
        if (obj.name === 'LINKEDIN') {
            signInJS.async = false;
            signInJS.text = ('api_key: ' + obj.id).replace('\'', '');
        }
        document.head.appendChild(signInJS);
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class FacebookLoginProvider extends BaseLoginProvider {
    /**
     * @param {?} clientId
     */
    constructor(clientId) {
        super();
        this.clientId = clientId;
        this.loginProviderObj = new LoginProviderClass();
        this.loginProviderObj.id = clientId;
        this.loginProviderObj.name = 'FACEBOOK';
        this.loginProviderObj.url = 'https://connect.facebook.net/en_US/sdk.js';
    }
    /**
     * @param {?} response
     * @return {?}
     */
    static drawUser(response) {
        /** @type {?} */
        const user = new SocialUser();
        user.id = response.id;
        user.name = response.name;
        user.email = response.email;
        user.token = response.token;
        user.photoUrl = 'https://graph.facebook.com/' + response.id + '/picture?type=normal';
        return user;
    }
    /**
     * @return {?}
     */
    initialize() {
        return new Promise((resolve, reject) => {
            this.loadScript(this.loginProviderObj, () => {
                FB.init({
                    appId: this.clientId,
                    autoLogAppEvents: true,
                    cookie: true,
                    xfbml: true,
                    version: 'v2.9'
                });
                this.isInitialize = true;
                FB.AppEvents.logPageView();
                FB.getLoginStatus(function (response) {
                    if (response.status === 'connected') {
                        /** @type {?} */
                        const accessToken = FB.getAuthResponse()['accessToken'];
                        FB.api('/me?fields=name,email,picture', (res) => {
                            resolve(FacebookLoginProvider.drawUser(Object.assign({}, { token: accessToken }, res)));
                        });
                    }
                });
            });
        });
    }
    /**
     * @return {?}
     */
    signIn() {
        return new Promise((resolve, reject) => {
            FB.login((response) => {
                if (response.authResponse) {
                    /** @type {?} */
                    const accessToken = FB.getAuthResponse()['accessToken'];
                    FB.api('/me?fields=name,email,picture', (res) => {
                        resolve(FacebookLoginProvider.drawUser(Object.assign({}, { token: accessToken }, res)));
                    });
                }
            }, { scope: 'email,public_profile' });
        });
    }
    /**
     * @return {?}
     */
    signOut() {
        return new Promise((resolve, reject) => {
            FB.logout((response) => {
                resolve();
            });
        });
    }
}
FacebookLoginProvider.PROVIDER_ID = 'FACEBOOK';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class GoogleLoginProvider extends BaseLoginProvider {
    /**
     * @param {?} clientId
     */
    constructor(clientId) {
        super();
        this.clientId = clientId;
        this.loginProviderObj = new LoginProviderClass();
        this.loginProviderObj.id = clientId;
        this.loginProviderObj.name = 'GOOGLE';
        this.loginProviderObj.url = 'https://apis.google.com/js/platform.js';
    }
    /**
     * @return {?}
     */
    initialize() {
        return new Promise((resolve, reject) => {
            this.loadScript(this.loginProviderObj, () => {
                gapi.load('auth2', () => {
                    this.isInitialize = true;
                    this.auth2 = gapi.auth2.init({
                        client_id: this.clientId,
                        scope: 'email'
                    });
                    this.auth2.then(() => {
                        if (this.auth2.isSignedIn.get()) {
                            resolve(this.drawUser());
                        }
                    });
                });
            });
        });
    }
    /**
     * @return {?}
     */
    drawUser() {
        /** @type {?} */
        const user = new SocialUser();
        /** @type {?} */
        const profile = this.auth2.currentUser.get().getBasicProfile();
        /** @type {?} */
        const authResponseObj = this.auth2.currentUser.get().getAuthResponse(true);
        user.id = profile.getId();
        user.name = profile.getName();
        user.email = profile.getEmail();
        user.photoUrl = profile.getImageUrl();
        user.token = authResponseObj.access_token;
        return user;
    }
    /**
     * @return {?}
     */
    signIn() {
        return new Promise((resolve, reject) => {
            /** @type {?} */
            const promise = this.auth2.signIn();
            promise.then(() => {
                resolve(this.drawUser());
            });
        });
    }
    /**
     * @return {?}
     */
    signOut() {
        return new Promise((resolve, reject) => {
            this.auth2.signOut().then((err) => {
                if (err) {
                    reject(err);
                }
                else {
                    resolve();
                }
            });
        });
    }
}
GoogleLoginProvider.PROVIDER_ID = 'GOOGLE';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class LinkedinLoginProvider extends BaseLoginProvider {
    /**
     * @param {?} clientId
     */
    constructor(clientId) {
        super();
        this.clientId = clientId;
        this.loginProviderObj = new LoginProviderClass();
        this.loginProviderObj.id = clientId;
        this.loginProviderObj.name = 'LINKEDIN';
        this.loginProviderObj.url = 'https://platform.linkedin.com/in.js';
    }
    /**
     * @return {?}
     */
    initialize() {
        return new Promise((resolve, reject) => {
            this.loadScript(this.loginProviderObj, () => {
                IN.init({
                    api_key: this.clientId,
                    authorize: true,
                    onLoad: this.onLinkedInLoad()
                });
                this.isInitialize = true;
                IN.Event.on(IN, 'auth', () => {
                    if (IN.User.isAuthorized()) {
                        IN.API.Raw('/people/~:(id,first-name,last-name,email-address,picture-url)').result((res) => {
                            resolve(this.drawUser(res));
                        });
                    }
                });
            });
        });
    }
    /**
     * @return {?}
     */
    onLinkedInLoad() {
        IN.Event.on(IN, 'systemReady', () => {
            IN.User.refresh();
        });
    }
    /**
     * @param {?} response
     * @return {?}
     */
    drawUser(response) {
        /** @type {?} */
        const user = new SocialUser();
        user.id = response.emailAddress;
        user.name = response.firstName + ' ' + response.lastName;
        user.email = response.emailAddress;
        user.photoUrl = response.pictureUrl;
        user.token = IN.ENV.auth.oauth_token;
        return user;
    }
    /**
     * @return {?}
     */
    signIn() {
        return new Promise((resolve, reject) => {
            IN.User.authorize(() => {
                IN.API.Raw('/people/~:(id,first-name,last-name,email-address,picture-url)').result((res) => {
                    resolve(this.drawUser(res));
                });
            });
        });
    }
    /**
     * @return {?}
     */
    signOut() {
        return new Promise((resolve, reject) => {
            IN.User.logout((response) => {
                resolve();
            }, (err) => {
                reject(err);
            });
        });
    }
}
LinkedinLoginProvider.PROVIDER_ID = 'LINKEDIN';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

export { SocialUser, LinkedInResponse, LoginProviderClass, FacebookLoginProvider, GoogleLoginProvider, LinkedinLoginProvider, SocialLoginModule, AuthServiceConfig, AuthService, BaseLoginProvider as ɵa };

